import React, { useEffect } from 'react';

import EmptyState from '@adsk/alloy-react-empty-state';
import { useLocale } from '@adsk/alloy-react-locale';

import { useFormsContext } from './FormsProvider';
import { ACTIONS } from './helpers/reducers/forms';

const FormsCustomPickerEmptyState = ({ dataViewProps }) => {
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));
  const { dispatch } = useFormsContext();
  useEffect(() => {
    dispatch({
      type: ACTIONS.UPDATE_FORM_TEMPLATE_CATEGORIES,
      payload: {
        templateCategories: dataViewProps?.templateCategories || [],
      },
    });
  }, [dispatch, dataViewProps]);

  return (
    <EmptyState
      illustrationType={EmptyState.ILLUSTRATION_TYPES.FOLDER_EMPTY_GREY}
      title={T.translate('NO_FORMS')}
      description={T.translate('NO_FORMS_DESCRIPTION')}
    />
  );
};

export default FormsCustomPickerEmptyState;
